<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4>{{title}}</h4>

		<c-table
			ref="table"
			:columns="columns"
			:endpoint="endpoint"
			:search="false">
		</c-table>

	</div>
</template>

<script>
import CTable from '@components/table/Table';

export default {
	components: { CTable },
	props: {
		endpoint: {
			required: true,
		},
		title: {
			required: true,
		},
        client_type_id: {
            required: true,
        }
	},
	computed: {
		columns() {
			if(this.client_type_id == this.$constants.client.EINDKLANT){
				return [
					{ name: 'client.name', label: 'Bedrijf' },
					{ name: 'first_name,last_name', label: 'Contactpersoon' },
					{ name: 'client.visiting_address.street,client.visiting_address.number,client.visiting_address.city', label: 'Locatie' },
					{ name: "client_id", label: '', component: 'CColumnButton', props: { route: 'customerDetail' }},
				];
			}
			else {
				return [
					{ name: 'first_name,last_name', label: 'Contactpersoon', sortable: true },
					{ name: 'title', label: 'functie' },
					{ name: 'client.visiting_address.street,client.visiting_address.number,client.visiting_address.city', label: 'Locatie' },
					{ name: "client_id", label: '', component: 'CColumnButton', props: { route: 'customerDetail' }},
				];
			}
		},
	}
}
</script>